
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1.5H4a2 2 0 00-2 2v10a1 1 0 002 0V13a29 29 0 008 0v.53a1 1 0 002 0V3.5a2 2 0 00-2-2zM4.5 2h7a.5.5 0 010 1h-7a.5.5 0 010-1zM4 11a1 1 0 111-1 1 1 0 01-1 1zm8 0a1 1 0 111-1 1 1 0 01-1 1zm1-3.91a.49.49 0 01-.41.49A25.45 25.45 0 018 8a25.45 25.45 0 01-4.59-.42.49.49 0 01-.41-.49V5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5z"}})])
          )
        }
      }
    